<template>
    <div>
        <footer>
                {{ texteFooter }} | <a href="#top">Haut</a>
        </footer>
    </div>
</template>

<script>

export default {
  name: 'footerV',
    data() {    
      return    {
                texteFooter : 'Emmanuel Trépant, 28 snijbos 1702 Dilbeek',
                }
            }
}
</script>
<style scoped>

footer,
footer a {

  background-color: #428bca;
  margin-top: 100px;
  height: 50px;
  line-height: 50px;
  color: white;
  text-align: center;
}

</style>